import { createFileRoute } from "@tanstack/react-router";
import InviteCard from "~/components/business/invite";

export const Route = createFileRoute("/$lang/profile/invite")({
	component: ProfileInvite,
});

export default function ProfileInvite() {
	return (
		<div className="pt-8 max-md:px-4">
			<InviteCard />
		</div>
	);
}
